/**
 * Created by danielg on 5/20/14.
 */
define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var BaseApiService = require('web-agent-utils/BaseApiService');


    var AcWrapper = {
        /**
         * Creates a wrapper for an Account Config Service
         * @param url - The URL of the service. Can be a string, and can be a URL-resolver style object.
         * @param serviceName - The (optional) name of the service. If none is provided - domainUrl will be used.
         * @param polling - can be set to "true" in case we want this request to be repeated every "pollingTimeout" milliseconds.
         * @param pollingTimeout - can be set to determine the timeout fr the polling, if not passed and polling is set to "true" the baseApiService default will be used (10 sec)
         * The name is used for logging purposes.
         * @returns An instance of a AC wrapper - with methods getValue, createValue, updateValue and deleteValue. Also
         * exposes property ETag, which is used on requests to determine if the data is up to date.
         */
        createInstance: function (url, serviceName) {
            var acWrapper = null;
            if (url) {
                var domainUrl;
                var additionalUrl;
                if (url.url && url.version) {
                    var fullUrl = agentLEManager.getLEUrlResolverGetUrl(url);
                    domainUrl = lpUtils.getSubDomain(fullUrl);
                    additionalUrl = fullUrl.substring(domainUrl.length);
                }
                acWrapper = BaseApiService.createInstance({domainUrl: domainUrl, postmessagePath: "/postmessage", serviceName: serviceName});
                acWrapper.additionalUrl = additionalUrl;
            }

            if (acWrapper) {
                /**
                 * Method for getting a value (or values) from an AC service, via callback (GET).
                 * @param reqObj - The request object. It should contain the following fields:
                 * success: Callback which will handle the returned data for a successful request.
                 * error: Callback which will handle a request that encountered an error.
                 * context: The context for the callback methods. Usually the object containing the methods.
                 * id: Optional. Will only send a request for the object with this id.
                 * data: Optional. An object containing additional query parameters for the request as mapped values.
                 *
                 * example reqObj:
                 * { success: function(context, data) {...}, error: function(context, data) {...}, context: this, id: 12345, data: {select: 'all', lang: 'en-US'}}
                 */
                acWrapper.getValue = function (reqObj) {
                    reqObj.callingFunction = 'getValue';
                    reqObj.method = 'GET';
                    reqObj.additionalUrl = acWrapper.additionalUrl;
                    acWrapper.sendRequest(reqObj);
                };


                acWrapper.startGetPollingRequest = function (reqObj) {
                    reqObj.callingFunction = 'getValue';
                    reqObj.method = 'GET';
                    reqObj.additionalUrl = acWrapper.additionalUrl;
                    acWrapper.startPolling(reqObj);
                };


                /**
                 * Method for creating a value (or values) from an AC service, via callback (POST).
                 * @param reqObj - The request object. It should contain the following fields:
                 * body: The body of the request.
                 * success: Callback which will handle the returned data for a successful request.
                 * error: Callback which will handle a request that encountered an error.
                 * context: The context for the callback methods. Usually the object containing the methods.
                 * id: Optional. Will only send a request for the object with this id. This is only relevant for APIs using POST to update values.
                 *
                 * example reqObj:
                 * { body: ..., success: function(context, data) {...}, error: function(context, data) {...}, context: this}
                 */
                acWrapper.createValue = function (reqObj) {
                    reqObj.callingFunction = 'createValue';
                    if (reqObj && reqObj.body) {
                        reqObj.method = 'POST';
                        reqObj.additionalUrl = acWrapper.additionalUrl;
                        acWrapper.sendRequest(reqObj);
                    }
                };

                /**
                 * Method for updating a value (or values) from an AC service, via callback (PUT).
                 * @param reqObj - The request object. It should contain the following fields:
                 * body: The body of the request.
                 * success: Callback which will handle the returned data for a successful request.
                 * error: Callback which will handle a request that encountered an error.
                 * context: The context for the callback methods. Usually the object containing the methods.
                 * id: Optional. Will only send a request for the object with this id.
                 *
                 * example reqObj:
                 * { body: ..., success: function(context, data) {...}, error: function(context, data) {...}, context: this, id: 12345}
                 *
                 * Note: Some APIs might use POST to update. This means you should use the "createValue" method.
                 */
                acWrapper.updateValue = function (reqObj) {
                    reqObj.callingFunction = 'updateValue';
                    if (reqObj && reqObj.body) {
                        reqObj.method = 'PUT';
                        reqObj.additionalUrl = acWrapper.additionalUrl;
                        acWrapper.sendRequest(reqObj);
                    }
                };

                /**
                 * Method for deleting a value from an AC service, via callback (DELETE).
                 * @param reqObj - The request object. It should contain the following fields:
                 * success: Callback which will handle the returned data for a successful request.
                 * error: Callback which will handle a request that encountered an error.
                 * context: The context for the callback methods. Usually the object containing the methods.
                 * id: Mandatory. Will delete the object with this id.
                 *
                 * example reqObj:
                 * { success: function(context, data) {...}, error: function(context, data) {...}, context: this, id: 12345}
                 */
                acWrapper.deleteValue = function (reqObj) {
                    reqObj.callingFunction = 'deleteValue';
                    if (reqObj && reqObj.id) {
                        reqObj.method = 'DELETE';
                        reqObj.additionalUrl = acWrapper.additionalUrl;
                        acWrapper.sendRequest(reqObj);
                    }
                };

                /**
                 * This method should be called in case we want to stop a request that was called with a "polling=true" property,
                 * hence it is polling every x seconds for new data.
                 * Currently the BaseApiService can support only one instance of request polling and therefore there is no need to
                 * specify which request polling we want to stop.
                 */
                acWrapper.stopCurrentRequestPolling = function () {
                    acWrapper.stopPolling();
                };
            }
            return acWrapper;
        }
    };

    return AcWrapper;

});
